<script>
	/*
	Sort geojson.features
	Loop through features properties
	Draw color bar from  activeMetric.colorScale
 */

	import {
		selectedFeature,
		activeFeature,
		activeMetric,
		tooltip,
	} from "./stores.js";
	import { getFeature, getValues, geoData } from "./utils";

	export let geojson;

	let features, id;

	// sort properties
	$: {
		// features = [...geojson.features].sort((a, b) => {
		features = [...geojson.features].sort((a, b) => {
			a = a.properties[$activeMetric.id];
			b = b.properties[$activeMetric.id];
			if (a == b) return 0;
			return a > b ? 1 : -1;
		});
		if ($activeMetric.direction == "d") features = features.reverse();
	}

	// get cell style
	$: getStyle = props => {
		if (!props || !$activeMetric) return;
		var n = props[$activeMetric.id];
		return `background:${$activeMetric.colorScale(n)}`;
		// return `background:${$activeMetric.colorScale(n)};flex:${n} 1 auto`;
	};

	function click(e) {
		$selectedFeature =
			$selectedFeature == $activeFeature ? getFeature() : $activeFeature;
	}

	function mousemove(e) {
		if (id != e.target.dataset.id) {
			id = e.target.dataset.id;
			$activeFeature = getFeature(id);

			$tooltip.text = `
				<span class="name">${$activeFeature.properties.NAME + " "}</span>
				<span class="num">${getValues($activeFeature, $activeMetric).formatted}</span>`;
		}

		// toooltip
		$tooltip.pageX = e.pageX;
		$tooltip.pageY = e.pageY;
		$tooltip.visible = true;
	}

	function mouseleave(e) {
		$activeFeature = $selectedFeature;
		$tooltip.visible = false;
		id = null;
	}
</script>

<div
	class="legend"
	on:click={click}
	on:mousemove={mousemove}
	on:mouseleave={mouseleave}>
	{#each features as feature}
		<span
			class="cell"
			class:active={feature == $activeFeature}
			class:selected={feature == $selectedFeature}
			style={getStyle(feature.properties)}
			data-id={feature.properties.id} />
		<!-- use:log={feature} -->
		<!-- class:selected={clickedState == feature.properties.NAME} -->
	{/each}
</div>
